// App dependencies
import { Skills } from '../skills/skills';
import { CreepType } from './creep.enum';

const HITS_STEP = 1000;
const CAPACITY_STEP = 100;
const MAX_LEVEL = 25;

export class Creep {
  public level = 0;

  static fromString(creepStr: string): Creep {
    const [_id, name, typeskills] = creepStr.split('_');
    const type: CreepType = parseInt(typeskills[0], 10);
    const skills = Skills.fromString(typeskills);

    return new Creep(_id, name, type, skills);
  }

  constructor(
    public _id: string,
    public name: string = '',
    private __type: 0 | CreepType = 0,
    public skills: Skills = new Skills
  ) {
    this.skills.creepRef = this;
    this.level = this.skills.toArray().reduce((creepLevel: number, { level }) => {
      return creepLevel + level;
    }, 0);
  }

  toString() {
    const str = `${ this._id }_${ this.name }_${ this.type || '' }${ this.skills }`;

    return str;
  }

  // Creep hits getter
  get hits(): number {
    return HITS_STEP + HITS_STEP * this.level;
  }

  // Creep capacity getter
  get capacity(): number {
    return CAPACITY_STEP + CAPACITY_STEP * this.level;
  }

  // Creep type getter and setter
  get type(): CreepType {
    return this.__type;
  }

  set type(type: CreepType) {
    if (this.__type !== type) {
      this.level = 0;
    }

    this.__type = type;
  }

  incLevel(): void {
    this.level++;
  }

  decLevel(): void {
    this.level--;
  }

  upgradeAvailable(): boolean {
    return this.level < MAX_LEVEL;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/creep/creep.ts